<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item">{{$t('Materials')}}</li>
        <li v-if="material" class="breadcrumb-item active" aria-current="page">{{ material.activitat_titol }}</li>
      </ol>
    </nav>

    <h1 v-if="material">{{material.activitat_titol}}</h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="material">

          <div class="card-body">

            <div class="m-t-20 row">
              <div class="col-md-2 col-xs-12 text-center mb-2">

                <a v-bind:href="material.activitat_original" target="_blank" rel="noreferrer noopener">
                  <img v-if="material.activitat_thumbnail" :src="material.activitat_thumbnail" @error="imageUrlAlt($event, material.activitat_rights)" alt="thumbnail" class="img-responsive float-left img-thumbnail">
                  <img v-else src="../../assets/images/no-thumbnail.png" alt="thumbnail" class="img-responsive float-left img-thumbnail rounded-0">
                </a>
              </div>

              <div class="col-md-10">

                <div>

                  <div class="row mb-2" v-if="material.activitat_professors">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('participants')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="(professor, index) in material.activitat_professors" :key="professor">
                        <div v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''">
                          <div class="mb-1">{{professor.split("##")[0]}} ({{$t(material.activitat_professors_roles[index])}})</div>
                        </div>
                        <div v-else>
                          <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                            <div class="mb-1">{{professor.split("##")[0]}} ({{$t(material.activitat_professors_roles[index])}})</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--div class="row mb-2" v-if="material.activitat_altresAutories">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Editor')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="(altre) in material.activitat_altresAutories" :key="altre">
                        <div v-if="altre.indexOf('##') === -1 || altre.split('##')[1] === ''">
                          <p class="mb-1">{{altre}}</p>
                        </div>
                        <div v-else>
                          <router-link :to="{name: 'professor', params: {id: altre.split('##')[1]}}">
                            <p class="mb-1">{{altre.split("##")[0]}}</p>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div-->
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus document')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(material.subtipus)}}</p>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('data')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.data}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_data_inicio && material.activitat_data_fi">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('data inici')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_data_inicio}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_data_fin && material.activitat_data_inicio">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('data fi')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_data_fin}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_rights">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('rights')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      {{$t(material.activitat_rights)}}
                      <span class="mr-2"></span>
                      <i v-if="material.activitat_rights === 'Open Access'" class="fas fa-lock-open text-warning" :title="material.activitat_rights"></i>
                      <img v-else-if="material.activitat_rights === 'Restricted access to the UPC academic community'" src="../../assets/images/obertupc.png" :title="material.activitat_rights" alt="Restricted access to the UPC academic community">
                      <img v-else-if="material.activitat_rights === 'Restricted access to the CSUC academic community'" src="../../assets/images/obertupc.png" :title="material.activitat_rights" alt="Restricted access to the CSUC academic community">
                      <i v-else class="fas fa-lock text-warning" :title="material.activitat_rights"></i>
                    </p>
                  </div>
                </div>


                <!--div class="row mb-2" v-if="material.activitat_rights_uri">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Llicència')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1"><a v-bind:href="material.activitat_rights_uri" target="_blank" rel="noreferrer noopener">{{$t(material.activitat_rights_uri)}}</a> </p>
                  </div>
                </div-->

                <div v-if="material.id.includes('_')">
                  <div class="row mb-2" v-if="material.activitat_rights_uri">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Llicència')}}</p></div>
                    <div class="col-md-9 col-xs-12">


                      <div class="alert alert-secondary d-flex align-items-start" role="alert">
                        <div class="me-3 flex-shrink-0">
                          <img
                              :src="require(`@/assets/images/cc/${material.activitat_rights_uri.match(/by(?:-[^/]+)*/)?.[0]}.png`)"
                              :alt="material.activitat_rights_uri.match(/by(?:-[^/]+)*/)?.[0]"
                              :title="material.activitat_rights_uri.match(/by(?:-[^/]+)*/)?.[0]"
                              style="max-height: 50px;"
                          >
                        </div>

                        <div class="flex-grow-1">
                          <span>{{ $t('cc-content') }}</span>
                          <p class="mb-1"><a v-bind:href="material.activitat_rights_uri" target="_blank" rel="noreferrer noopener">{{$t(material.activitat_rights_uri.match(/by(?:-[^/]+)*/)?.[0])}}</a> </p>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row mb-2" v-else>
                    <div class="col-md-3 col-xs-12"></div>
                    <div class="col-md-9 col-xs-12">
                      <div class="alert alert-secondary" role="alert">
                        <span class="fw-bolder">{{ $t('no-cc-title') }}</span>
                        <span>{{ $t('no-cc-content') }}</span>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mb-2" v-if="material.activitat_publisher != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Editorial')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_publisher}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_academicyear != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('any academic')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_academicyear}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_version != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Versió')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_version}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_has_version != null">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Última versió')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      <router-link :to="{name: 'material', params: {id: material.activitat_has_version}}">{{material.activitat_has_version}}</router-link>
                    </p>
                  </div>
                </div>

                <hr>

                <div class="row mb-2" v-if="material.activitat_llenguatge">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('llenguatge')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_llenguatge}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_plataforma">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('plataforma')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{material.activitat_plataforma}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_isbn">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">ISBN</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="isbn in material.activitat_isbn" v-bind:key="isbn">
                      <span class="mb-2">{{isbn}}</span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_dl">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Dipòsit legal')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{material.activitat_dl}}
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_titol_cataleg">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('titol cataleg')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{material.activitat_titol_cataleg}}
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_editorial">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Editorial')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{material.activitat_editorial}}
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_exposicio">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('exposicio')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{material.activitat_exposicio}}
                  </div>
                </div>


                <div class="row mb-2" v-if="material.activitat_centres">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centre Docent')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="centre in material.activitat_centres" v-bind:key="centre">
                      <span class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: centre}}">{{$t(centre)}}</router-link></span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_assignatures">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Assignatures')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="assignatura in material.activitat_assignatures" v-bind:key="assignatura">
                      <span class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura}}">{{$t(assignatura)}}</router-link></span>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_titulacions">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="titulacio in material.activitat_titulacions" v-bind:key="titulacio">
                      <span class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}"><translate>{{$t(titulacio)}}</translate></router-link></span>
                    </div>
                  </div>
                </div>

                <hr>

                <div class="row mb-2" v-if="material.activitat_urlWeb">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">URL</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="material.activitat_urlWeb" target="_blank" rel="noreferrer noopener">{{material.activitat_urlWeb}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_urlEprints">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">UPCommons</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="material.activitat_urlEprints" target="_blank" rel="noreferrer noopener">{{material.activitat_urlEprints}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_zonavideo">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">Zonavideo</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="material.activitat_zonavideo" target="_blank" rel="noreferrer noopener">{{material.activitat_zonavideo}}</a>
                  </div>
                </div>

                <div class="row mb-2" v-if="material.activitat_resum">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Resum')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="(resum, index) in material.activitat_resum" v-bind:key="resum">
                      <span v-if="index !== (material.activitat_resum.length-1)" class="mb-4">{{resum}}</span>
                      <span v-else>{{resum}}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-4 mb-2" v-if="material.subtipus === 'Audiovisual'">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Vídeo')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-if="material.activitat_zonavideo">
                      <iframe allowfullscreen="allowfullscreen" style="border: 0;" height="295" width="100%" id="pumukitiframe" :src="material.activitat_zonavideo.replaceAll('/video/', '/iframe/')"></iframe>
                    </div>
                  </div>
                </div>


                <hr v-if="material.activitat_colaborador">
                <div class="row mb-2" v-if="material.activitat_colaborador">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Entitat col·laboradora')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="(colaborador, index) in material.activitat_colaborador" v-bind:key="colaborador">
                      <span v-if="index !== (material.activitat_colaborador-1)" class="mb-4">{{colaborador}}</span>
                      <span v-else>{{resum}}</span>
                    </div>
                  </div>
                </div>

                <hr v-if="material.activitat_grups">

                <div class="row mb-1" v-if="material.activitat_grups">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Grups de recerca')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="grup in material.activitat_grups" v-bind:key="grup">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: grup}}">{{$t(grup)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <hr v-if="material.activitat_geolocalitzacio">
                <div class="row mb-2" v-if="material.activitat_geolocalitzacio">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Localització')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <span v-for="(geo, index) in material.activitat_geolocalitzacio" v-bind:key="geo">
                        <small style="color: #007bc1; font-weight: 200;"><i class="fas fa-map-marker-alt"></i><sup>{{ index+1 }}</sup> <a href="javascript:void(0);" @click='selectGeolocation(geo)'>{{geo.split(";")[2].split("=")[1]}}</a></small><br>
                    </span>


                    <l-map ref="mapControl" :options="mapOptions" style="height: 300px" @ready="onReady">
                      <l-tile-layer :url="url" :attribution="attribution"/>
                      <l-marker :key="index"
                                v-for="(geo, index) in material.activitat_geolocalitzacio"
                                :lat-lng='[geo.split(";")[1].split("=")[1], geo.split(";")[0].split("=")[1]]'>
                        <l-popup>
                          <div>
                            {{index+1}} - {{geo.split(";")[2].split("=")[1]}}
                          </div>
                        </l-popup>
                      </l-marker>
                    </l-map>
                  </div>
                </div>
              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <template v-if="material.id.startsWith('2099_') || material.id.startsWith('2117_')">
                    <img src="../../assets/images/mini-upc.svg" width="20" alt="UPCommons" class="me-1 d-none d-lg-block img-fluid">
                    <a class="me-4 d-none d-lg-block" :href="'http://hdl.handle.net/' + material.id.replace('_','/')" target="_blank" rel="noreferrer noopener">UPCommons <i class="fa-solid fa-external-link mini-icon"></i></a>
                  </template>
                  <template v-else>
                    <span class="me-4 d-none d-lg-block">&nbsp;</span>
                  </template>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Extracto Inteligente potenciado con IA -->
    <IntelligentExtractCard v-if="material?.id" :materialId="material.id" />

    <h2 v-if="material.activitat_professors" class="fw-bold mt-5">{{$t('participants')}}</h2>

    <div class="row" v-if="material">
      <div class="col-sm-12 col-md-12 mt-2 mx-3">
          <div v-for="(professor, index) in material.activitat_professors" :key="professor">
            <div v-if="professor.indexOf('##') === -1 ||professor.split('##')[1] === ''">
                <i class="fa-regular fa-user text-secondary fa-lg mb-4"></i> {{professor.split("##")[0]}} ({{$t(material.activitat_professors_roles[index])}})
            </div>
            <div v-else>
              <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                  <i class="fa-regular fa-user fa-lg mb-4"></i>
                  {{professor.split("##")[0]}} ({{$t(material.activitat_professors_roles[index])}})
              </router-link>
            </div>
          </div>
      </div>
    </div>

    <h2 v-if="material.activitat_original != null" class="fw-bold mt-4">{{$t('Arxius')}}</h2>

    <div class="row" v-if="material && material.activitat_zonavideo == null">
      <div class="col-sm-12 col-md-12 mx-3">
        <div v-for="(arxiu) in material.activitat_original" :key="arxiu" class="mt-3">

          <a :href="arxiu" target="blank_" class="">
            <i class="fa-regular fa-file fa-lg"></i>
            {{decodeURIComponent(arxiu.split("/")[arxiu.split("/").length-1])}}
            <i class="fa-solid fa-external-link mini-icon"></i>
          </a>

        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import store from "@/store";
import {imageUrlAlt} from "@/utils/utils";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import IntelligentExtractCard from "@/components/IntelligentExtractCard.vue";


  export default {
    name: "ActivitatMaterialView",
    methods: {imageUrlAlt},
    components: {RouterLinkLocale, IntelligentExtractCard},

    props: {
      material: Object,
    },

    // eslint-disable-next-line no-unused-vars
    setup(props) {
      const response = ref([]);
      const responseMaterials = ref([]);
      const route = useRoute();

      const totalElements = ref(0)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");

      onMounted(async () => {
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
      });

      return {
        response,
        responseMaterials,

        selectedOrder,
        totalElements,
        pageSize
      }
    }
  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
